(() => {
  // ===== LocalStorage keys =====
  const ANON_ID_KEY = "omni_anon_id";
  const KEY_MODAL_SHOWN = "omni_wishlist_guest_modal_shown";
  const KEY_MODAL_SUPPRESS = "omni_wishlist_guest_modal_suppress";
  
  // pending: anonIdごとに「ログイン後にsyncしたい」フラグ
  const LS_SYNC_PENDING_KEY = (anonId) => `omni_wishlist_sync_pending_${anonId}`;
  
  // synced: shop + customerIdごとに「同期済み」フラグ
  const LS_SYNCED_KEY = (shop, customerId) => `omni_wishlist_synced_${shop}_${customerId}`;

  // ===== App Proxy endpoints =====
  const EP_STATUS = "/apps/wishlist/status";
  const EP_TOGGLE = "/apps/wishlist/toggle";
  const EP_SYNC = "/apps/wishlist/sync";

  // ===== Controls =====
  let syncInFlight = false;
  const SHOP_DOMAIN = window.Shopify?.shop || "default";
  
  // グローバルに公開（多重起動防止）- マージ形式で上書きしない
  window.OMNI = window.OMNI || {};
  if (window.OMNI.wishlistSyncInFlight === undefined) {
    window.OMNI.wishlistSyncInFlight = false;
  }

  // ===== 商品ごとの状態管理（連打対応：直列化キュー） =====
  // productGid → state の Map
  const wishlistStates = new Map();

  function getAnonId() {
    let anon = localStorage.getItem(ANON_ID_KEY);
    if (!anon) {
      anon = crypto.randomUUID();
      localStorage.setItem(ANON_ID_KEY, anon);
    }
    return anon;
  }

  function safeJsonParse(text) {
    try { return JSON.parse(text); } catch { return null; }
  }

  // customerId の取得（proxyがくれた値 > Liquidフォールバック）
  function getCustomerIdFallback(proxyCustomerId) {
    if (proxyCustomerId) return String(proxyCustomerId);
    if (window.OMNI && window.OMNI.customerId) return String(window.OMNI.customerId);
    return "";
  }

  async function fetchTextJson(url, options) {
    const res = await fetch(url, {
      credentials: "same-origin",
      headers: { "Accept": "application/json", ...(options?.headers || {}) },
      ...options
    });
    const text = await res.text();
    const json = safeJsonParse(text);
    return { res, text, json };
  }

  // ===== Modal =====
  function shouldShowGuestModal() {
    if (localStorage.getItem(KEY_MODAL_SHOWN) === "1") return false;
    if (localStorage.getItem(KEY_MODAL_SUPPRESS) === "1") return false;
    return true;
  }

  function markModalShown() {
    localStorage.setItem(KEY_MODAL_SHOWN, "1");
  }

  function ensureGuestModal() {
    if (document.getElementById("omniWishlistModalOverlay")) return;

    const overlay = document.createElement("div");
    overlay.id = "omniWishlistModalOverlay";
    overlay.className = "omni-wishlist-modal__overlay";
    overlay.style.display = "none";
    overlay.innerHTML = `
      <div class="omni-wishlist-modal" role="dialog" aria-modal="true" aria-labelledby="omni-wishlist-modal-title">
        <button type="button" class="omni-wishlist-modal__close-x" data-action="close" aria-label="閉じる">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div class="omni-wishlist-modal__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#e48406" stroke="#e48406" stroke-width="1.5" width="40" height="40">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </div>

        <h2 id="omni-wishlist-modal-title" class="omni-wishlist-modal__title">お気に入りに追加しました</h2>

        <!-- 注意事項 -->
        <div class="omni-wishlist-modal__notice">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>お気に入りは商品の確保（取り置き）ではありません</span>
        </div>

        <!-- 会員メリット -->
        <div class="omni-wishlist-modal__benefits">
          <h3 class="omni-wishlist-modal__benefits-title">会員登録のメリット</h3>
          <ul class="omni-wishlist-modal__benefits-list">
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              端末間で同期（スマホ・PC）
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              保存期限なし（ゲストは60日）
            </li>
          </ul>
          <a class="omni-wishlist-modal__btn omni-wishlist-modal__btn--primary" data-action="signup"
             href="/account/login?return_url=${encodeURIComponent(location.pathname + location.search)}">
             会員登録・ログイン
          </a>
        </div>

        <!-- セール通知（メール登録） -->
        <div class="omni-wishlist-modal__notify">
          <h3 class="omni-wishlist-modal__notify-title">セール通知を受け取る</h3>
          <p class="omni-wishlist-modal__notify-desc">
            お気に入り商品がセールになったらメールでお知らせします。<br>
            <small>※会員登録とは別の登録です。いつでも解除できます。</small>
          </p>
          <div class="omni-wishlist-modal__notify-form" data-notify-form>
            <input type="email" class="omni-wishlist-modal__notify-input" placeholder="メールアドレス" data-notify-email required>
            <label class="omni-wishlist-modal__notify-consent">
              <input type="checkbox" data-notify-consent>
              <span>セール通知を受け取る</span>
            </label>
            <button type="button" class="omni-wishlist-modal__btn omni-wishlist-modal__btn--notify" data-action="notify-subscribe">
              メールで通知を受け取る
            </button>
            <p class="omni-wishlist-modal__notify-success" data-notify-success style="display:none;">
              ✓ 登録しました！セール時にお知らせします。
            </p>
            <p class="omni-wishlist-modal__notify-error" data-notify-error style="display:none;">
              登録に失敗しました。もう一度お試しください。
            </p>
          </div>
        </div>

        <!-- フッター -->
        <div class="omni-wishlist-modal__footer">
          <label class="omni-wishlist-modal__check">
            <input type="checkbox" id="omniWishlistHideNext">
            <span>今後表示しない</span>
          </label>
          <button type="button" class="omni-wishlist-modal__btn omni-wishlist-modal__btn--ghost" data-action="close">閉じる</button>
        </div>
      </div>
    `;

    // CSS injection (scoped)
    const style = document.createElement("style");
    style.textContent = `
      .omni-wishlist-modal__overlay{
        position:fixed; inset:0; background:rgba(0,0,0,.5);
        display:flex; align-items:center; justify-content:center;
        z-index:9999; padding:16px; overflow-y:auto;
      }
      .omni-wishlist-modal{
        position:relative;
        width:min(480px, 100%); background:#fff; border-radius:16px;
        padding:24px 20px; box-shadow:0 10px 40px rgba(0,0,0,.2);
        max-height:90vh; overflow-y:auto;
      }
      .omni-wishlist-modal__close-x{
        position:absolute; top:12px; right:12px;
        background:none; border:none; cursor:pointer;
        color:#666; padding:4px;
      }
      .omni-wishlist-modal__close-x:hover{ color:#111; }
      .omni-wishlist-modal__icon{
        text-align:center; margin-bottom:12px;
      }
      .omni-wishlist-modal__title{
        font-size:20px; font-weight:700; margin:0 0 16px; text-align:center;
      }
      .omni-wishlist-modal__notice{
        display:flex; align-items:center; gap:8px;
        padding:10px 12px; background:#fef3cd; border-radius:8px;
        font-size:13px; color:#856404; margin-bottom:20px;
      }
      .omni-wishlist-modal__notice svg{ flex-shrink:0; }
      .omni-wishlist-modal__benefits{
        padding:16px; background:#f8f9fa; border-radius:12px; margin-bottom:20px;
      }
      .omni-wishlist-modal__benefits-title{
        font-size:14px; font-weight:700; margin:0 0 10px; color:#333;
      }
      .omni-wishlist-modal__benefits-list{
        list-style:none; padding:0; margin:0 0 12px;
      }
      .omni-wishlist-modal__benefits-list li{
        display:flex; align-items:center; gap:8px;
        font-size:13px; color:#555; margin-bottom:6px;
      }
      .omni-wishlist-modal__benefits-list svg{ color:#22c55e; flex-shrink:0; }
      .omni-wishlist-modal__notify{
        padding:16px; background:#fff5eb; border:1px solid #fed7aa; border-radius:12px; margin-bottom:20px;
      }
      .omni-wishlist-modal__notify-title{
        font-size:14px; font-weight:700; margin:0 0 8px; color:#c2410c;
      }
      .omni-wishlist-modal__notify-desc{
        font-size:12px; color:#666; margin:0 0 12px; line-height:1.5;
      }
      .omni-wishlist-modal__notify-desc small{ color:#999; }
      .omni-wishlist-modal__notify-form{
        display:flex; flex-direction:column; gap:10px;
      }
      .omni-wishlist-modal__notify-input{
        width:100%; padding:10px 12px; font-size:14px;
        border:1px solid #ddd; border-radius:8px;
      }
      .omni-wishlist-modal__notify-input:focus{
        outline:none; border-color:#e48406;
      }
      .omni-wishlist-modal__notify-consent{
        display:flex; align-items:center; gap:8px; font-size:13px; cursor:pointer;
      }
      .omni-wishlist-modal__notify-consent input{ width:18px; height:18px; accent-color:#e48406; }
      .omni-wishlist-modal__btn--notify{
        background:#e48406; color:#fff; border:none; padding:12px 16px;
        border-radius:8px; font-weight:600; cursor:pointer; font-size:14px;
      }
      .omni-wishlist-modal__btn--notify:hover{ background:#c97305; }
      .omni-wishlist-modal__btn--notify:disabled{ background:#ccc; cursor:not-allowed; }
      .omni-wishlist-modal__notify-success{
        color:#22c55e; font-size:13px; margin:0; text-align:center;
      }
      .omni-wishlist-modal__notify-error{
        color:#dc2626; font-size:13px; margin:0; text-align:center;
      }
      .omni-wishlist-modal__footer{
        display:flex; align-items:center; justify-content:space-between;
        flex-wrap:wrap; gap:12px; padding-top:16px; border-top:1px solid #eee;
      }
      .omni-wishlist-modal__check{
        display:flex; align-items:center; gap:6px; font-size:12px; color:#666; cursor:pointer;
      }
      .omni-wishlist-modal__check input{ width:16px; height:16px; }
      .omni-wishlist-modal__btn{
        border-radius:8px; padding:10px 16px; text-decoration:none;
        display:inline-flex; align-items:center; justify-content:center;
        font-size:14px; cursor:pointer; border:1px solid #ddd; background:#fff; color:#111;
        font-weight:500;
      }
      .omni-wishlist-modal__btn--primary{
        width:100%; border-color:#111; background:#111; color:#fff;
      }
      .omni-wishlist-modal__btn--primary:hover{ background:#333; }
      .omni-wishlist-modal__btn--ghost{ background:#fff; }
      .omni-wishlist-modal__btn--ghost:hover{ background:#f5f5f5; }
    `;
    overlay.appendChild(style);

    function closeModal() {
      const cb = overlay.querySelector("#omniWishlistHideNext");
      if (cb && cb.checked) localStorage.setItem(KEY_MODAL_SUPPRESS, "1");
      overlay.style.display = "none";
    }

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) closeModal();
    });
    
    overlay.querySelectorAll('[data-action="close"]').forEach(btn => {
      btn.addEventListener("click", closeModal);
    });
    
    overlay.querySelector('[data-action="signup"]')?.addEventListener("click", () => {
      const cb = overlay.querySelector("#omniWishlistHideNext");
      if (cb && cb.checked) localStorage.setItem(KEY_MODAL_SUPPRESS, "1");
    });

    // Notify subscribe handler
    overlay.querySelector('[data-action="notify-subscribe"]')?.addEventListener("click", async () => {
      const emailInput = overlay.querySelector("[data-notify-email]");
      const consentInput = overlay.querySelector("[data-notify-consent]");
      const successEl = overlay.querySelector("[data-notify-success]");
      const errorEl = overlay.querySelector("[data-notify-error]");
      const submitBtn = overlay.querySelector('[data-action="notify-subscribe"]');

      const email = emailInput?.value?.trim();
      const consent = consentInput?.checked;

      // Validation
      if (!email || !email.includes("@")) {
        emailInput?.focus();
        return;
      }
      if (!consent) {
        consentInput?.focus();
        return;
      }

      // Submit
      submitBtn.disabled = true;
      successEl.style.display = "none";
      errorEl.style.display = "none";

      try {
        const res = await fetch("/apps/wishlist/notify/subscribe", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            consent_sale: true,
            identity_kind: "guest",
            anon_id: getAnonId()
          })
        });
        const data = await res.json();

        if (data.ok) {
          successEl.style.display = "block";
          localStorage.setItem("omni_wishlist_notify_email", email);
          localStorage.setItem("omni_wishlist_notify_consent_sale", "1");
          // Hide form
          overlay.querySelector("[data-notify-form]").style.display = "none";
          successEl.style.display = "block";
        } else {
          throw new Error(data.error || "Failed");
        }
      } catch (err) {
        console.error("[wishlist] notify subscribe error", err);
        errorEl.style.display = "block";
        submitBtn.disabled = false;
      }
    });

    // Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && overlay.style.display !== "none") closeModal();
    });

    document.body.appendChild(overlay);
  }

  function openGuestModal() {
    ensureGuestModal();
    const overlay = document.getElementById("omniWishlistModalOverlay");
    if (overlay) {
      overlay.style.display = "flex";
      markModalShown();
    }
  }

  function maybeShowGuestFirstModal(data) {
    if (!data) return;
    if (data.identity_kind !== "anon") return;
    if (data.active !== true) return;
    if (!shouldShowGuestModal()) return;
    openGuestModal();
  }

  // ===== Sync logic =====
  async function callSync(anonId) {
    const res = await fetch(EP_SYNC, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ anon_id: anonId }),
      credentials: "same-origin",
    });
    const data = await res.json().catch(() => ({}));
    return { ok: !!data.ok, data, status: res.status };
  }

  async function maybeRunSync({ shop, anonId, proxyCustomerId, hasLoggedInCustomerId }) {
    // pending がなければ何もしない
    if (!localStorage.getItem(LS_SYNC_PENDING_KEY(anonId))) {
      return;
    }

    const customerId = getCustomerIdFallback(proxyCustomerId);

    // 「ログインが確実」判定：proxyがtrue、または Liquid の isLoggedIn が true
    const loggedIn =
      !!hasLoggedInCustomerId ||
      (window.OMNI && window.OMNI.isLoggedIn === true);

    if (!loggedIn) {
      return;
    }

    // customerId が取れたら "同期済み" を顧客単位で判定
    if (customerId) {
      if (localStorage.getItem(LS_SYNCED_KEY(shop, customerId))) {
        // 既に同期済み → pendingを消す
        localStorage.removeItem(LS_SYNC_PENDING_KEY(anonId));
        return;
      }
    }

    // 多重実行防止（グローバルフラグも確認）
    if (syncInFlight || window.OMNI.wishlistSyncInFlight) return;
    syncInFlight = true;
    window.OMNI.wishlistSyncInFlight = true;

    try {
      const { ok, data } = await callSync(anonId);

      if (ok) {
        // 同期完了：pendingを消して同期済みを保存
        localStorage.removeItem(LS_SYNC_PENDING_KEY(anonId));
        if (customerId) {
          localStorage.setItem(LS_SYNCED_KEY(shop, customerId), "1");
        }
        console.log("[wishlist] sync completed", data);
      } else {
        // サーバが retryable を返したら pending は残す（次の機会に再試行）
        console.log("[wishlist] sync not done (retryable), will retry later", data);
      }
    } catch (err) {
      console.error("[wishlist] sync error", err);
    } finally {
      syncInFlight = false;
      window.OMNI.wishlistSyncInFlight = false;
    }
  }

  // ===== 全ページ共通：ログイン直後のpending同期（B） =====
  async function syncPendingIfNeeded() {
    const anonId = getAnonId();
    
    // pending がなければ何もしない（ノーコスト）
    if (!localStorage.getItem(LS_SYNC_PENDING_KEY(anonId))) {
      return;
    }

    // 多重起動防止
    if (window.OMNI.wishlistSyncInFlight) {
      return;
    }

    // ログイン状態確認（Liquid側の情報を優先）
    const isLoggedIn = window.OMNI && window.OMNI.isLoggedIn === true;
    const customerId = window.OMNI && window.OMNI.customerId ? String(window.OMNI.customerId) : "";

    if (!isLoggedIn) {
      return;
    }

    // 既に同期済みなら pending だけ消す
    if (customerId && localStorage.getItem(LS_SYNCED_KEY(SHOP_DOMAIN, customerId))) {
      localStorage.removeItem(LS_SYNC_PENDING_KEY(anonId));
      console.log("[wishlist] already synced, removed pending");
      return;
    }

    // 同期実行
    window.OMNI.wishlistSyncInFlight = true;

    try {
      const { ok, data } = await callSync(anonId);

      if (ok) {
        localStorage.removeItem(LS_SYNC_PENDING_KEY(anonId));
        if (customerId) {
          localStorage.setItem(LS_SYNCED_KEY(SHOP_DOMAIN, customerId), "1");
        }
        console.log("[wishlist] global sync completed on page load", data);
      } else {
        console.warn("[wishlist] global sync failed (retryable), pending preserved", data);
      }
    } catch (err) {
      console.error("[wishlist] global sync error", err);
    } finally {
      window.OMNI.wishlistSyncInFlight = false;
    }
  }

  // ===== Public helpers used by UI binding =====
  async function getStatus(productGid) {
    const anon_id = getAnonId();
    const url = `${EP_STATUS}?product_gid=${encodeURIComponent(productGid)}&anon_id=${encodeURIComponent(anon_id)}`;
    const { res, text, json } = await fetchTextJson(url, { method: "GET" });

    if (!json || !json.ok) {
      console.warn("[wishlist] status failed", { status: res.status, head: text.slice(0, 120) });
      return null;
    }

    // status取得後に同期を試す（ページ表示だけでsyncが走る）
    await maybeRunSync({
      shop: SHOP_DOMAIN,
      anonId: anon_id,
      proxyCustomerId: json.customer_id,
      hasLoggedInCustomerId: json.has_logged_in_customer_id
    });

    return json;
  }

  // toggle API呼び出し（純粋な通信処理のみ）
  async function callToggle(productGid, productHandle) {
    const anon_id = getAnonId();
    const { res, text, json } = await fetchTextJson(EP_TOGGLE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ product_gid: productGid, anon_id })
    });

    if (!json || !json.ok) {
      console.warn("[wishlist] toggle failed", { status: res.status, head: text.slice(0, 120) });
      throw new Error("toggle failed");
    }

    // ★ゲストの場合はLocalStorageに永続化（最優先）
    if (json.ok && (json.identity_kind === "anon" || json.identity_kind === "guest")) {
      if (window.OMNI && window.OMNI.wishlist && window.OMNI.wishlist.getLocalWishlistItems) {
        try {
          let items = window.OMNI.wishlist.getLocalWishlistItems();
          const now = Date.now();

          if (json.active) {
            // 追加: 既に存在するなら重複させない
            const exists = items.some(it => it.handle === productHandle || it.productGid === productGid);
            if (!exists && productHandle) {
              items.push({ handle: productHandle, productGid: productGid, addedAt: now });
              console.log("[wishlist] localStorage: added " + productHandle);
            }
          } else {
            // 削除
            const before = items.length;
            items = items.filter(it => it.handle !== productHandle && it.productGid !== productGid);
            if (items.length < before && productHandle) {
              console.log("[wishlist] localStorage: removed " + productHandle);
            }
          }

          window.OMNI.wishlist.saveLocalWishlistItems(items);
        } catch (e) {
          console.warn("[wishlist] localStorage update failed", e);
        }
      }
    }

    // anonの場合はpendingを立てる（ログイン後に同期するため）
    if (json.ok && json.identity_kind === "anon" && anon_id) {
      localStorage.setItem(LS_SYNC_PENDING_KEY(anon_id), "1");
    }

    // 1件目モーダル：ゲストが初めて active=true になった瞬間だけ
    maybeShowGuestFirstModal(json);

    // もしログイン状態が取れていれば、その場で同期も試す
    await maybeRunSync({
      shop: SHOP_DOMAIN,
      anonId: anon_id,
      proxyCustomerId: json.customer_id,
      hasLoggedInCustomerId: json.has_logged_in_customer_id
    });

    return json;
  }

  // 商品ごとの状態を取得（初回は生成）
  function getWishlistState(productGid) {
    if (!wishlistStates.has(productGid)) {
      wishlistStates.set(productGid, {
        desiredActive: false,   // 最後に押したい状態
        displayedCount: 0,      // 画面に出しているcount（即時反映用）
        serverActive: false,    // 直近のサーバー確定
        serverCount: 0,         // 直近のサーバー確定
        syncing: false,         // 直列化フラグ
        dirty: false,           // クリックが追加で入ったか
      });
    }
    return wishlistStates.get(productGid);
  }

  // 直列化：通信は必ず1本ずつ。最後の意図に追いつくまで繰り返す
  async function syncWishlistUntilCaughtUp(productGid, productHandle) {
    const state = getWishlistState(productGid);
    state.syncing = true;

    while (state.dirty) {
      state.dirty = false;

      try {
        // toggle APIを1回だけ叩く（同時送信しない）
        const res = await callToggle(productGid, productHandle);

        // サーバー確定値を更新
        state.serverActive = !!res.active;
        state.serverCount = Number(res.count ?? state.serverCount);

        // ここが肝：
        // 通信中にさらにクリックされて desiredActive が変わっていたら、
        // "まだ追いついてない"ので dirty を立ててもう一周する。
        if (state.desiredActive !== state.serverActive) {
          state.dirty = true;
          // UIはすでに desired を表示してるので、ここでは敢えてサーバー値で上書きしない（チラつき防止）
          // 次のtoggleで追いつかせる
        } else {
          // 追いついたら最終的にサーバーcountで確定（ドリフト解消）
          state.displayedCount = state.serverCount;
          updateAllButtons(productGid, {
            active: state.serverActive,
            count: state.serverCount
          });
        }
      } catch (e) {
        // 失敗時：サーバー確定値に戻す
        console.error("[wishlist] toggle error, rolling back", e);
        state.desiredActive = state.serverActive;
        state.displayedCount = state.serverCount;
        updateAllButtons(productGid, {
          active: state.serverActive,
          count: state.serverCount
        });
        // エラー時はループを抜ける（次のクリックで再試行）
        state.dirty = false;
      }
    }

    state.syncing = false;
  }

  // ===== Wiring (existing button can call these) =====
  async function init() {
    // 【B】全ページ共通：ログイン直後のpending同期
    // ページ種別に依存せず、ログイン済みならpendingを自動同期
    await syncPendingIfNeeded();

    // ページ上の対象ボタンを探す
    const btns = document.querySelectorAll("[data-omni-wishlist][data-product-gid]");
    if (!btns.length) return;

    // 同一productGidでグループ化
    const productGids = new Set();
    btns.forEach(btn => {
      const gid = btn.getAttribute("data-product-gid");
      if (gid) productGids.add(gid);
    });

    // 各商品ごとに初期状態を取得
    for (const productGid of productGids) {
      const st = await getStatus(productGid);
      if (st) {
        // 状態を初期化
        const state = getWishlistState(productGid);
        state.desiredActive = !!st.active;
        state.displayedCount = Number(st.count ?? 0);
        state.serverActive = !!st.active;
        state.serverCount = Number(st.count ?? 0);
        
        updateAllButtons(productGid, st);
      }
    }

    // クリックイベント登録（全ボタンに対して）【連打対応：直列化キュー】
    btns.forEach(btn => {
      const productGid = btn.getAttribute("data-product-gid");
      const productHandle = btn.getAttribute("data-product-handle");
      if (!productGid) return;

      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const state = getWishlistState(productGid);

        // 1) "最後の意図"を反転（連打でも毎回受ける）
        state.desiredActive = !state.desiredActive;

        // 2) 即時反映（UIは必ず動く）
        state.displayedCount = Math.max(
          0,
          state.displayedCount + (state.desiredActive ? 1 : -1)
        );
        updateAllButtons(productGid, {
          active: state.desiredActive,
          count: state.displayedCount
        });

        // 3) 通信ループへ（通信中でも return しない）
        state.dirty = true;
        if (!state.syncing) {
          syncWishlistUntilCaughtUp(productGid, productHandle);
        }
      });
    });
  }

  function updateAllButtons(productGid, data) {
    const btns = document.querySelectorAll(`[data-omni-wishlist][data-product-gid="${productGid}"]`);
    btns.forEach(btn => {
      btn.classList.toggle("omni-wishlist-btn--active", !!data.active);
      const countEl = btn.querySelector("[data-omni-wishlist-count]");
      if (countEl) countEl.textContent = String(data.count ?? 0);
      btn.setAttribute("aria-pressed", data.active ? "true" : "false");
    });

    // ★ ヘッダーバッジを必ず更新（data.count を使用）
    // data.total_count がある時だけだと更新されないバグがあったため修正
    const total = Number(data.count ?? 0);
    
    // 直接更新（omni-wishlist-header.js の関数を呼ぶ）
    if (typeof window.updateWishlistBadges === "function") {
      window.updateWishlistBadges(total);
    }
    
    // 保険でイベントも発火（互換用）
    window.dispatchEvent(new CustomEvent("omni:wishlist:count", { 
      detail: { count: total } 
    }));
    window.dispatchEvent(new CustomEvent("omni:wishlist:count-change", { 
      detail: { count: total, reason: "toggle" } 
    }));
  }

  // ===== Header Badge Integration =====
  function dispatchWishlistCountEvent(count) {
    window.dispatchEvent(new CustomEvent("omni:wishlist:count", { 
      detail: { count: Number(count) } 
    }));
  }

  // ===== ヘッダー更新ロジック：omni-wishlist-header.js に完全移譲 =====
  // 
  // ★ 重要：ヘッダーバッジの更新は omni-wishlist-header.js の
  //         updateWishlistBadges(count) に一本化されました。
  //
  // このファイル（omni-wishlist.js）からのヘッダー直接更新は
  // 「ページ跨ぎでの上書き事故」の原因になるため、すべて無効化しています。
  //
  // ヘッダー更新は updateAllButtons() 内で window.updateWishlistBadges() を
  // 呼ぶことで実現されます。
  // =============================================================

  // 以下の関数は無効化（omni-wishlist-header.js が担当）
  function updateHeaderBadge(count) {
    // 無効化：omni-wishlist-header.js の updateWishlistBadges() を使用
    console.log("[wishlist] updateHeaderBadge is deprecated, use window.updateWishlistBadges()");
  }

  // イベントリスナーも無効化（omni-wishlist-header.js が購読）
  // window.addEventListener("omni:wishlist:count", (e) => {
  //   const count = e.detail?.count ?? 0;
  //   updateHeaderBadge(count);
  // });

  async function fetchTotalWishlistCount() {
    // 無効化：omni-wishlist-header.js が初期化時に取得
    console.log("[wishlist] fetchTotalWishlistCount is deprecated, header.js handles initialization");
  }

  const WISHLIST_ITEMS_KEY = "omni_wishlist_items";
  const GUEST_TTL_MS = 60 * 24 * 60 * 60 * 1000; // 60 days

  function getLocalWishlistItems() {
    try {
      const raw = localStorage.getItem(WISHLIST_ITEMS_KEY);
      if (!raw) return [];
      const obj = JSON.parse(raw);
      // 新形式: { items: [...] } または 旧形式: [...]
      const items = Array.isArray(obj.items) ? obj.items : (Array.isArray(obj) ? obj : []);
      const now = Date.now();
      return items.filter(item => {
        if (!item.addedAt) return true;
        return (now - item.addedAt) < GUEST_TTL_MS;
      });
    } catch {
      return [];
    }
  }

  function saveLocalWishlistItems(items) {
    localStorage.setItem(WISHLIST_ITEMS_KEY, JSON.stringify(items));
  }

  // Clean up expired guest wishlist items (60 days TTL)
  function cleanupExpiredWishlistItems() {
    const items = getLocalWishlistItems();
    const originalLength = items.length;
    
    // getLocalWishlistItems already filters out expired items
    // Just save the cleaned list back
    if (items.length !== originalLength) {
      saveLocalWishlistItems(items);
      console.log(`[wishlist] Cleaned up ${originalLength - items.length} expired items`);
    }
  }

  // Initialize header badge on page load
  async function initHeaderBadge() {
    // 無効化：omni-wishlist-header.js が初期化を担当
    console.log("[wishlist] initHeaderBadge is deprecated, header.js handles initialization");
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Clean up expired guest items first
    cleanupExpiredWishlistItems();
    
    init();
    // initHeaderBadge() は呼ばない（omni-wishlist-header.js が担当）
  });
})();
